/** Ensure all union types are present in returned array */
export function exhaustiveArray<T extends string>() {
  return <U extends Record<T, T>>(obj: U & Record<T, T>) => Object.values(obj) as T[]
}
